import steps from '@steps/steps'

const mount = () => {
  window.onpopstate = (event) => {
    const { state } = event
    const user = state && state.user
    const stageId = state && state.stageId

    steps.show({ stageId, user })
  }
}

const changeHistory = ({ user, stageId, path }) => {
  window.history.pushState({ user, stageId }, '', `/${path}/`)
  steps.show({ user, stageId })
}

export default { mount, changeHistory }
